import React from 'react';
import { MapContext } from 'react-map-gl';

interface IMapMarker {
    longitude: number;
    latitude: number;
    icon: React.ReactNode;
    onClick: (arg: any) => void;
}

function MapMarker({ longitude, latitude, icon, onClick }: IMapMarker) {
    const context: any = React.useContext(MapContext);
    const [x, y] = context
                    .viewport
                    .project([longitude, latitude]);

    const markerStyle: React.CSSProperties = {
      position: 'absolute',
      left: x,
      top: y,
      cursor: "pointer"
    };
  
    return (
      <div onClick={onClick} style={markerStyle}>
        {icon}
      </div>
    );
}

export default MapMarker;